<template lang="html">
  <div>
    <div v-if="title" class="inputLabel">{{ title }}</div>
    <li class="none" :class="[col === 1 ? '' : 'col2']">
      <slot></slot>
    </li>
    <p v-if="col === 1 && !err" class="err">{{ description }}</p>
    <p v-else-if="col === 2 && !(err && errAdd)" class="err">{{ description }}</p>
    <p v-else>{{ description }}</p>
  </div>
</template>

<script>

  export default {
    props: {
      data: Object,
      dataAdd: Object,
      description: String,
      title: String,

      col: {
        type: Number,
        default: 1
      }
    },

    computed: {
      err() {  return this.data.validate; },
      errAdd() {  return this.dataAdd.validate; },
    },

    data() {
      return {
      }
    }
  }
</script>

<style lang="css" scoped>
  .v-application ul {
    padding-left: 0px;
  }
  
  li.none {
    list-style: none;
  }

  p {
    padding: 9px 10px 0;
    color: #7f8081;
    font-size: 13px;
    line-height: 16px;
    margin-bottom: 16px;
  }

  .err {
    color: #ff3636;
  }
</style>

